<template>
  <div>
    <div class="inst-title">파일 확장자 검사</div>
    <pre class="inst-desc">
현재 한양3D팩토리가 지원하는 파일 확장자는 STL, OBJ, STEP 파일입니다.
      잘못된 확장자 변환을 시도하거나, 파일이 손상된 경우  문제가 발생하게 됩니다.</pre
    >

    <div class="inst-subtitle">[해결방법]</div>

    <pre class="inst-desc">다른 3D 프로그램에서도 해당 파일이 잘 불러와 지는지 확인</pre>
  </div>
</template>

<script setup></script>
